import { toast } from 'sonner';
import { config } from '../config';
/**
 * Sign up a new tenant/organization
 */
export async function signup(request) {
    const identityApiUrl = config.api.identity;
    try {
        const response = await fetch(`${identityApiUrl}/signup`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request),
        });
        const data = await response.json();
        if (!response.ok) {
            const error = data;
            // Handle specific error codes
            if (error.code === 'DUPLICATE_ACCOUNT') {
                toast.error('Account already exists', {
                    description: 'An account with this email address already exists. Please sign in instead.',
                });
            }
            else {
                toast.error('Signup failed', {
                    description: error.error || 'Failed to create account. Please try again.',
                });
            }
            throw new Error(error.error || 'Signup failed');
        }
        toast.success('Account created!', {
            description: 'Check your email to verify your account.',
        });
        return data;
    }
    catch (error) {
        // Network or unexpected errors
        if (error instanceof Error && error.message.includes('fetch')) {
            toast.error('Network error', {
                description: 'Unable to connect to the server. Please check your internet connection.',
            });
        }
        throw error;
    }
}
/**
 * Verify email with code (future implementation)
 */
export async function verifyEmail(email, code) {
    const identityApiUrl = config.api.identity;
    try {
        const response = await fetch(`${identityApiUrl}/verify-email`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, code }),
        });
        if (!response.ok) {
            const error = (await response.json());
            toast.error('Verification failed', {
                description: error.error || 'Invalid or expired verification code.',
            });
            throw new Error(error.error || 'Verification failed');
        }
        toast.success('Email verified!', {
            description: 'You can now sign in with your credentials.',
        });
    }
    catch (error) {
        throw error;
    }
}
/**
 * Resend verification code (future implementation)
 */
export async function resendVerification(email) {
    const identityApiUrl = config.api.identity;
    try {
        const response = await fetch(`${identityApiUrl}/resend-verification`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
        });
        if (!response.ok) {
            const error = (await response.json());
            toast.error('Failed to resend', {
                description: error.error || 'Unable to resend verification code.',
            });
            throw new Error(error.error || 'Resend failed');
        }
        toast.success('Code sent!', {
            description: 'Check your email for a new verification code.',
        });
    }
    catch (error) {
        throw error;
    }
}
